import { render, staticRenderFns } from "./TwoTruthsLie.vue?vue&type=template&id=2ba9b66b&scoped=true"
import script from "./TwoTruthsLie.vue?vue&type=script&lang=ts"
export * from "./TwoTruthsLie.vue?vue&type=script&lang=ts"
import style0 from "./TwoTruthsLie.vue?vue&type=style&index=0&id=2ba9b66b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9b66b",
  null
  
)

export default component.exports